import React, { useEffect, useState, useRef } from 'react'
import { StyleSheet, css } from 'aphrodite'

const ScrollText = ({ media, sectionStyle = {} }) => {
  // Destructure properties from media
  const {
    text,
    durationSecs: duration = 20, // Fallback to 20 if not provided
    backgroundColor = '#fff',
    foregroundColor = '#000',
    direction = 'LTR',
    speed = 'MEDIUM'
  } = media

  // Keep track of dynamic font size in state
  const [fontSize, setFontSize] = useState(16)
  // New state to control when the text is fully laid out
  const [layoutReady, setLayoutReady] = useState(false)
  const textRef = useRef(null)

  // Define scroll direction animations
  // Right -> Left
  const animationRightToLeft = {
    '0%': { transform: 'translateX(' + sectionStyle.width + ')' }, // Starts off the right edge
    '100%': { transform: 'translateX(-100%)' } // Ends off the left edge
  }
  // Left -> Right
  const animationLeftToRight = {
    '0%': { transform: 'translateX(-100%)' }, // Starts off the left edge
    '100%': { transform: 'translateX(' + sectionStyle.width + ')' }  // Ends off the right edge
  }

  // Speed Calculation Start ----
  // Decide scroll speed based on "speed"
  let baseSpeed = 12000
  switch (speed) {
  case 'SLOW':
    baseSpeed = 20000
    break
  case 'MEDIUM':
    baseSpeed = 12000
    break
  case 'FAST':
    baseSpeed = 6000
    break
  default:
    baseSpeed = 12000
    break
  }

  const textCountcount = text && text.length || 1
  const textSpeed = baseSpeed * (textCountcount / 20)

  /*
  const baseTextCount = 20;
  const baseSectionWidth = 1280
  // Estimate text width based on the assumption that for 20 characters the width is equal to baseSectionWidth.
  const estimatedTextWidth = (text.length / baseTextCount) * baseSectionWidth
  // Total travel distance is the section's width plus the estimated text width.
  const totalDistance = parseInt(sectionStyle.width) + estimatedTextWidth
  // The baseline total distance (for 20 characters on a 1280-width section) is:
  const baselineDistance = baseSectionWidth + baseSectionWidth // 2560
  // The duration scales linearly with the travel distance.
  const textSpeed = baseSpeed * (totalDistance / baselineDistance)
  // Speed Calculation ENDS ---- */

  // Dynamically create Aphrodite styles for the scrolling text
  const dynamicStyles = StyleSheet.create({
    text: {
      display: 'inline-block',
      whiteSpace: 'nowrap', // Keeps text in one line
      animationName: direction === 'RTL' ? animationRightToLeft : animationLeftToRight,
      animationDuration: `${textSpeed}ms`,
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite',
      willChange: 'transform',
      color: foregroundColor,
      fontSize: `${fontSize}px`
    }
  })

  // Calculate a new font size so text fits vertically based on sectionStyle.height
  useEffect(() => {
    if (sectionStyle.height && sectionStyle.height.includes('px')) {
      const numericHeight = parseInt(sectionStyle.height, 10)
      const newFontSize = numericHeight * 0.6
      setFontSize(newFontSize > 120 ? 120 : newFontSize)
    }
  }, [sectionStyle.height])

  // Once text layout is complete, mark layout as ready to attach animation
  // Also need to add some delay while attaching the animation, that will help section to complete render and then get proper width height & position for animation
  // With out using delay, text render most of the time, mismatched, display inline block get miss calculated by dom
  useEffect(() => {
    if (textRef.current) {
      setTimeout(() => { setLayoutReady(true) }, 400)
    }
  }, [])

  return (
    <div className={css(Styles.marquee)} style={{ backgroundColor, width: sectionStyle.width }}>
      <span
        ref={textRef}
        className={css(layoutReady ? dynamicStyles.text : null)}
        style={{ visibility: layoutReady ? 'visible' : 'hidden' }}
      >
        {text}
      </span>
    </div>
  )
}

const Styles = StyleSheet.create({
  marquee: {
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    // width: '100%',  // Fills available width
    height: '100%', // Fills available height
    alignItems: 'center' // Vertically center the text
  }
})

export default ScrollText



// WEBPACK FOOTER //
// ./src/components/ScrollText.js